import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import "./hm-theme.css";

function EmployeeFamilyDetails(props) {
  const { userid } = useParams();
  const [loading, setLoading] = useState(false);
  const [familyDetails, setFamilyDetails] = useState([]);
  const navigate = useNavigate();

  const getData = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem("data")).token;
      const response = await axios.get(`/api/familydetails/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFamilyDetails(response.data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else if (error.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error.response?.data?.code) {
      toast.error(error.response.data.code);
    } else {
      toast.error(error.message || "An error occurred.");
    }
  }

  useEffect(() => {
    getData();
  }, [userid]);

  const openFamilyProfileModal = (memberid) => {
    navigate(`/users/family-profile/${memberid}`);
  };

  const getRelationshipBadge = (rel) => {
    if (!rel) return null;
    const map = {
      SPOUSE: "hm-badge hm-badge-info",
      CHILD: "hm-badge hm-badge-success",
      PARENT: "hm-badge hm-badge-warning",
    };
    return map[rel?.toUpperCase()] || "hm-badge hm-badge-primary";
  };

  return (
    <div>
      {loading && <div className="loading"></div>}

      {/* Section Header */}
      <div className="hm-card-header mb-3" style={{ background: "transparent", border: "none", padding: "0 0 0.5rem 0" }}>
        <h4 className="hm-card-title">
          <i className="material-icons">groups</i>
          Family Members
        </h4>
        <span className="hm-badge hm-badge-primary">{familyDetails.length} members</span>
      </div>

      {/* Table */}
      <div className="hm-card">
        <div className="hm-card-body p-0">
          {familyDetails.length === 0 ? (
            <div className="hm-empty-state">
              <i className="material-icons">group_off</i>
              <p className="fw-semibold mb-1">No family members added</p>
              <p className="text-muted small">Add family members to book appointments on their behalf.</p>
            </div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table className="hm-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Date of Birth</th>
                    <th>Gender</th>
                    <th>Phone</th>
                    <th>Relationship</th>
                  </tr>
                </thead>
                <tbody>
                  {familyDetails.map((member, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-link p-0 fw-semibold text-start"
                          style={{ color: "#2f3a88", textDecoration: "none" }}
                          onClick={() => openFamilyProfileModal(member.id)}
                          title="View Family Profile"
                        >
                          <i className="material-icons align-middle me-1" style={{ fontSize: "1rem" }}>person</i>
                          {member.name}
                        </button>
                      </td>
                      <td>{member.dob || "—"}</td>
                      <td>
                        <span style={{ textTransform: "capitalize" }}>{member.gender?.toLowerCase() || "—"}</span>
                      </td>
                      <td>{member.phoneNumber || "—"}</td>
                      <td>
                        <span className={getRelationshipBadge(member.relationship)}>
                          {member.relationship || "—"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default EmployeeFamilyDetails;